import { AxiosPromise }                       from 'axios';
import { Layout }                             from '@/components/chart/chart.types';
import { chartUuidMock }                      from '@/helpers/variables';
import { ChartPosition }                      from '@/components/chart/helpers/chart-variables';
import { FilterStylesObject, SelectedFilter } from '@/components/filter-panel/filter-panel.types';
import { ObjectWithStringKeys }               from '@/types';
import { FilterConfiguration }                from '@/components/chart/chart-wrapper/store/chart-wrapper.state.store';
import { GeneralTabs }                        from '@/views/dteop/dteop.types';
import { client }                             from '@/service/client';

export const getDteopChartDataService = (filters: Partial<SelectedFilter>[], functions: string[], trackedTabName: string, leadFilter: string): AxiosPromise => (
  client.post('/reports/day-to-end-of-period/data', {
    filters,
    functions,
    tabName: trackedTabName ? trackedTabName.toUpperCase() : GeneralTabs.SEGMENTS.toUpperCase(),
    leadFilter,
  }));

export const getAvailableDteopFiltersAndFunctions = (): AxiosPromise => client.get('/reports/day-to-end-of-period/filters-section');


export function getChartLayoutService(): Promise<Layout[]> {
  return new Promise((resolve) => {
    resolve([
      { chartUuid: chartUuidMock, layoutCode: ChartPosition.TOP_LEFT },
    ]);
  });
}

export function getDteopChartSettings(): AxiosPromise {
  return client.get('/reports/day-to-end-of-period-view-configuration');
}

export function saveDteopChartSettings(payload: ObjectWithStringKeys<boolean>): AxiosPromise {
  return client.put('/reports/day-to-end-of-period-view-configuration', payload);
}

export function getDteopFilterAllConfigurations(): AxiosPromise {
  return client.get('/reports/day-to-end-of-period/filter-snapshot');
}

export function getDteopFilterConfiguration(configurationName: string): AxiosPromise {
  return client.get(`/reports/day-to-end-of-period/filter-snapshot/${configurationName}`);
}

export function createDteopFilterConfiguration(configuration: FilterConfiguration): AxiosPromise {
  return client.put('/reports/day-to-end-of-period/filter-snapshot', { ...configuration });
}

export function removeDteopFilterConfiguration(configurationName: string): AxiosPromise {
  return client.delete(`/reports/day-to-end-of-period/filter-snapshot/${configurationName}`);
}

export function saveDteopFiltersStylesConfiguration(filtersConfig: FilterStylesObject): AxiosPromise {
  return client.put('/reports/day-to-end-of-period/filters-section', filtersConfig);
}
